import React from "react";

export const ZOHO_SUPPORT_FORM_SRC =
    "https://forms.zohopublic.com/fourminutemedicine1/form/Weareheretohelpcontactusanytime/formperma/hlFpw9eU9qi4D972ynkfVR6f-e4FsZgrhKqbr3iXEP4";

/**
 * Embeds the Zoho “We are here to help” contact form (used on /support and elsewhere).
 */
const SupportContactEmbed = ({ className = "" }) => {
    return (
        <iframe
            title="Contact support — Zoho form"
            aria-label="We are here to help, contact us anytime!"
            className={`block h-[500px] w-[99%] max-w-full border-0 mx-auto ${className}`}
            src={ZOHO_SUPPORT_FORM_SRC}
        />
    );
};

export default SupportContactEmbed;
